<template>


    <Transition name="modal-fade">
      <div v-if="isdisplay" class="cf-overlay" @click.self="close">
        <Transition name="modal-slide">
          <div v-if="isdisplay" class="cf-dialog cf-dialog--lg">

                <!-- Header -->
                <div class="cf-modal-head cf-dialog-head">
                    <div class="cf-modal-head__main">
                        <span class="cf-modal-head__icon"><i class="ri-image-add-line"></i></span>
                        <div>
                            <h4 class="cf-dialog-title">{{ titlemodal }}</h4>
                            <p class="cf-modal-head__sub">Photo de l'article</p>
                        </div>
                    </div>
                    <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                </div>

                <!-- Body -->
                <div class="cf-dialog-body">

                    <!-- Message (succès / erreur) -->
                    <div v-if="feedback.text" class="pa-feedback" :class="feedback.type === 'error' ? 'pa-feedback--error' : 'pa-feedback--success'">
                        <i :class="feedback.type === 'error' ? 'ri-error-warning-line' : 'ri-checkbox-circle-line'"></i>
                        <span>{{ feedback.text }}</span>
                    </div>

                    <!-- Barre d'espace disque -->
                    <div class="pa-quota">
                        <div class="pa-quota__head">
                            <span><i class="ri-hard-drive-2-line"></i> Espace disque</span>
                            <span class="pa-quota__val">{{ quota.usedMo }} / {{ quota.maxMo }} Mo</span>
                        </div>
                        <div class="pa-quota__bar">
                            <div class="pa-quota__fill" :class="{ 'pa-quota__fill--full': quota.atteint }" :style="{ width: pourcentage + '%' }"></div>
                        </div>
                        <p v-if="quota.atteint && !photoUrl" class="pa-quota__warn"><i class="ri-error-warning-line"></i> Espace saturé : impossible d'ajouter une nouvelle photo.</p>
                    </div>

                    <!-- Photo actuelle -->
                    <div v-if="photoUrl && !apercu" class="pa-current">
                        <p class="pa-label">Photo actuelle</p>
                        <div class="pa-preview">
                            <img :src="photoUrl" alt="Photo actuelle" class="pa-preview__img">
                            <button type="button" class="pa-preview__remove" title="Supprimer" @click="doDelete"><i class="ri-delete-bin-line"></i></button>
                        </div>
                    </div>

                    <!-- Aperçu de la nouvelle image sélectionnée -->
                    <div v-if="apercu" class="pa-current">
                        <p class="pa-label">Aperçu (à enregistrer)</p>
                        <div class="pa-preview">
                            <img :src="apercu" alt="Aperçu" class="pa-preview__img">
                            <button type="button" class="pa-preview__remove" title="Annuler" @click="clearApercu"><i class="ri-close-line"></i></button>
                        </div>
                    </div>

                    <!-- Zone de sélection -->
                    <div class="pa-drop">
                        <input ref="fileinput" type="file" accept="image/jpeg,image/png" class="pa-file" @change="onFileChange">
                        <div class="pa-drop__inner" @click="$refs.fileinput.click()">
                            <i class="ri-upload-cloud-2-line pa-drop__icon"></i>
                            <p class="pa-drop__title">{{ photoUrl ? 'Choisir une autre image' : 'Cliquez pour choisir une image' }}</p>
                            <p class="pa-drop__hint">JPEG ou PNG — redimensionnée en 100×100</p>
                        </div>
                    </div>

                </div>

                <!-- Footer -->
                <div class="cf-dialog-foot">
                    <button v-if="apercu" @click="doUpload" type="button" class="ti-btn ti-btn-primary-full" :disabled="loading">
                        <i class="ri-save-line align-middle"></i> {{ loading ? 'Envoi...' : 'Enregistrer la photo' }}
                    </button>
                    <button @click="close" type="button" class="ti-btn ti-btn-secondary-full">Fermer</button>
                </div>

          </div>
        </Transition>
      </div>
    </Transition>


</template>

<script>

    const axios = require('axios');

    import { randomString } from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";

    export default {
        /* eslint-disable */
        name: "modalphotoarticle",

        data() {
            return {
                isdisplay: false,
                titlemodal: "",
                article: null,
                articlepid: "",
                photoUrl: "",
                apercu: "",
                selectedFile: null,
                loading: false,
                quota: { maxMo: 1, usedMo: 0, resteMo: 1, atteint: false },
                feedback: { type: '', text: '' },
            };
        },

        computed: {
            pourcentage() {
                if (!this.quota.maxMo || this.quota.maxMo <= 0) return 0;
                let p = (this.quota.usedMo / this.quota.maxMo) * 100;
                if (p > 100) p = 100;
                if (p < 0) p = 0;
                return Math.round(p);
            },
        },

        methods: {

            setFeedback(type, text) {
                this.feedback = { type: type, text: text };
                if (type === 'error') { this.$toast?.error(text); }
                else { this.$toast?.success(text); }
            },

            clearFeedback() {
                this.feedback = { type: '', text: '' };
            },

            onFileChange(e) {

                let file = e.target.files && e.target.files[0];
                if (!file) { return; }

                const okMime = ['image/jpeg', 'image/png'].includes(file.type);
                if (!okMime) {
                    this.setFeedback('error', "Le fichier doit être une image JPEG ou PNG.");
                    this.clearApercu();
                    return;
                }

                this.clearFeedback();

                this.selectedFile = file;

                let t = this;
                let reader = new FileReader();
                reader.onload = function (ev) {
                    t.apercu = ev.target.result;
                };
                reader.readAsDataURL(file);

            },

            clearApercu() {
                this.apercu = "";
                this.selectedFile = null;
                if (this.$refs.fileinput) { this.$refs.fileinput.value = ""; }
            },

            headers() {
                return {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + JwtService.getToken(),
                    'csrftoken': this.$store.state.appsociete
                };
            },

            async loadQuota() {

                const t = this;
                let url = process.env.VUE_APP_API_URL + '/jkebfiuebffeznfoieznofibeubqsyudfyegl745874stock771714dfe/stock/photoarticle/quota/' + this.$store.state.appsociete + '/' + randomString();

                await axios.get(url, { headers: this.headers(), withCredentials: true })
                    .then(function (res) {
                        if (res.data && res.data.success && res.data.quota) {
                            t.quota = res.data.quota;
                        }
                    })
                    .catch(function () { /* silencieux */ });

            },

            async doUpload() {

                if (!this.selectedFile) { return; }

                this.loading = true;
                this.$store.dispatch('lancerchargement', true);

                const t = this;
                let form = new FormData();
                form.append('file', this.selectedFile);

                let url = process.env.VUE_APP_API_URL + '/jkebfiuebffeznfoieznofibeubqsyudfyegl745874stock771714dfe/stock/photoarticle/upload/' + this.articlepid + '/' + this.$store.state.appsociete + '/' + randomString();

                await axios.post(url, form, {
                    headers: Object.assign({}, this.headers(), { 'Content-Type': 'multipart/form-data' }),
                    withCredentials: true
                })
                    .then(function (res) {
                        if (res.data && res.data.success) {
                            t.photoUrl = t.$store.state.baseurlapifile + res.data.photo;
                            if (res.data.quota) { t.quota = res.data.quota; }
                            if (t.article && t.article.datajsonarticles) { t.article.datajsonarticles.photo = res.data.photo; }
                            t.clearApercu();
                            t.setFeedback('success', res.data.message || "Photo enregistrée.");
                        } else {
                            let msg = (res.data && res.data.mdataerror && res.data.mdataerror.length) ? res.data.mdataerror[0] : (res.data && res.data.message) ? res.data.message : "Échec de l'enregistrement.";
                            if (res.data && res.data.quota) { t.quota = res.data.quota; }
                            t.setFeedback('error', msg);
                        }
                    })
                    .catch(function (error) {
                        let msg = "Erreur réseau lors de l'envoi de la photo.";
                        if (error && error.response && error.response.data && error.response.data.message) { msg = error.response.data.message; }
                        t.setFeedback('error', msg);
                    })
                    .finally(function () {
                        t.loading = false;
                        t.$store.dispatch('lancerchargement', false);
                    });

            },

            async doDelete() {

                if (!this.photoUrl) { return; }

                this.$store.dispatch('lancerchargement', true);

                const t = this;
                let url = process.env.VUE_APP_API_URL + '/jkebfiuebffeznfoieznofibeubqsyudfyegl745874stock771714dfe/stock/photoarticle/delete/' + this.articlepid + '/' + this.$store.state.appsociete + '/' + randomString();

                await axios.post(url, {}, { headers: this.headers(), withCredentials: true })
                    .then(function (res) {
                        if (res.data && res.data.success) {
                            t.photoUrl = "";
                            if (res.data.quota) { t.quota = res.data.quota; }
                            if (t.article && t.article.datajsonarticles) { t.article.datajsonarticles.photo = ""; }
                            t.setFeedback('success', res.data.message || "Photo supprimée.");
                        } else {
                            let msg = (res.data && res.data.mdataerror && res.data.mdataerror.length) ? res.data.mdataerror[0] : "Échec de la suppression.";
                            t.setFeedback('error', msg);
                        }
                    })
                    .catch(function () {
                        t.setFeedback('error', "Erreur réseau lors de la suppression.");
                    })
                    .finally(function () {
                        t.$store.dispatch('lancerchargement', false);
                    });

            },

            close() {
                this.isdisplay = false;
            },

            show(value) {

                this.article = value;
                this.articlepid = (value && value.pid) ? value.pid : "";
                this.titlemodal = (value && value.libelle) ? value.libelle : "Article";

                let $photo = (value && value.datajsonarticles && value.datajsonarticles.photo) ? value.datajsonarticles.photo : "";
                this.photoUrl = $photo ? (this.$store.state.baseurlapifile + $photo) : "";

                this.clearApercu();
                this.clearFeedback();
                this.isdisplay = true;

                this.loadQuota();

            },

        },

    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:94vh; overflow:hidden; }
.cf-dialog--lg { max-width:640px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }

.pa-feedback { display:flex; align-items:flex-start; gap:0.5rem; padding:0.7rem 0.9rem; border-radius:var(--cf-radius-sm); font-size:0.82rem; margin-bottom:1rem; }
.pa-feedback--error { background:#fee2e2; color:#991b1b; }
.pa-feedback--success { background:#dcfce7; color:#166534; }

.pa-quota { margin-bottom:1.1rem; }
.pa-quota__head { display:flex; align-items:center; justify-content:space-between; font-size:0.8rem; color:var(--cf-ink-strong); font-weight:600; margin-bottom:0.35rem; }
.pa-quota__val { color:var(--cf-muted); font-weight:500; }
.pa-quota__bar { height:8px; border-radius:999px; background:var(--cf-surface-alt); overflow:hidden; }
.pa-quota__fill { height:100%; background:rgb(var(--primary)); transition:width 0.3s ease; }
.pa-quota__fill--full { background:rgb(var(--danger)); }
.pa-quota__warn { margin:0.4rem 0 0; font-size:0.75rem; color:rgb(var(--danger)); display:flex; align-items:center; gap:0.3rem; }

.pa-label { margin:0 0 0.4rem; font-size:0.78rem; font-weight:600; color:var(--cf-muted); }
.pa-current { margin-bottom:1rem; }

.pa-file { display:none; }
.pa-drop { border:1px dashed var(--cf-border); border-radius:var(--cf-radius); background:var(--cf-surface-alt); }
.pa-drop__inner { display:flex; flex-direction:column; align-items:center; justify-content:center; gap:0.35rem; padding:1.6rem 1rem; cursor:pointer; text-align:center; }
.pa-drop__icon { font-size:1.8rem; color:rgb(var(--primary)); }
.pa-drop__title { margin:0; font-size:0.85rem; font-weight:600; color:var(--cf-ink-strong); }
.pa-drop__hint { margin:0; font-size:0.75rem; color:var(--cf-muted); }

.pa-preview { position:relative; display:inline-block; }
.pa-preview__img { max-width:220px; max-height:220px; border-radius:var(--cf-radius-sm); border:1px solid var(--cf-border); display:block; }
.pa-preview__remove { position:absolute; top:-8px; right:-8px; height:1.7rem; width:1.7rem; display:inline-flex; align-items:center; justify-content:center; border:none; border-radius:50%; background:rgb(var(--danger)); color:#fff; cursor:pointer; }

.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }

@media screen and (max-width: 768px) {
    .cf-dialog--lg { max-width:100%; }
}
</style>
